import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import withErrorBoundary from "../../components/withErrorBoundary";

import Home from '../Home/homePage';
import DailyStatisticsPage from '../DailyStatistics/dailyStatisticsPage';
import ClinicsPage from "../Clinics/clinicsPage";
import Databases from "../Databases/databases";
import Backups from "../Backups/backups";
import Logs from '../GeneralLogs/index';
import CreateNewClinic from '../Clinics/createNewClinic';
import ClinicDetails from '../Clinics/ClinicDetails/clinicDetails';
import UserDetails from '../User/Details/userDetails';
import AuditLogs from '../AuditLogs/auditLogs';
import IcmdConfiguration from '../Icmd/IcmdConfiguration';
import AiClinician from "../AiClinician/AiClinician";

const routes = [
  {
    path: "",
    key: "Home",
    component: withErrorBoundary(Home)
  },
  {
    path: "home",
    key: "Home",
    component: withErrorBoundary(Home)
  },
  {
    path: "clinics",
    key: "Clinics",
    component: withErrorBoundary(ClinicsPage)
  },
  {
    path: "databases",
    key: "Databases",
    component: withErrorBoundary(Databases)
  },
  {
    path: "backups",
    key: "Backups",
    component: withErrorBoundary(Backups)
  },
  {
    path: "logs",
    key: "Logs",
    component: withErrorBoundary(Logs)
  },
  {
    path: "createNewClinic",
    key: "CreateNewClinic",
    component: withErrorBoundary(CreateNewClinic)
  },
  {
    path: "clinicDetails/:clinicId",
    key: "ClinicDetails",
    component: withErrorBoundary(ClinicDetails)
  },
  {
    path: "clinicDetails/:clinicId/:selectedTab",
    key: "ClinicDetails",
    component: withErrorBoundary(ClinicDetails)
  },
  {
    path: "userDetails/:userId",
    key: "UserDetails",
    component: withErrorBoundary(UserDetails)
  },
  {
    path: "auditLogs",
    key: "auditLogs",
    component: withErrorBoundary(AuditLogs)
  },
  {
    path:"dailyStatistics",
    key:"dailyStatistics",
    component:withErrorBoundary(DailyStatisticsPage)
  },
  {
    path:"icmd",
    key:"icmd",
    component:withErrorBoundary(IcmdConfiguration)
  },
  {
    path:"aiClinician",
    key:"aiClinician",
    component:withErrorBoundary(AiClinician)
  }
];

class AppRouter extends Component {
  render() {
    const { url } = this.props;
    return (
      <Switch>
        {
          routes.map((singleRoute) => {
            const { path, exact, component, ...otherProps } = singleRoute;
            // const wrappedComponent = withErrorBoundary(component);
            return (
              <Route
                exact={exact === false ? false : true}
                key={path}
                path={`${url}/${path}`}
                component={component}
                {...otherProps}
              />
            );
          })
        }
        <Route
          exact={true}
          path={'*'}
          component={() => <Redirect to={'/Dashboard'} />}
        />
      </Switch>
    );
  }
}

export default AppRouter;
